<h3 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Application Error</h3>
<mat-dialog-content>
  @if (!config?.devMode) {
    <div class="detail-card">
      We've encountered an unexpected error and cannot complete the operation, Please try again. If the problem persists, please complete an
      ACHIEVE Support Request. Click on 'Generate Log' to produce a log file and attach to the ACHIEVE Support Request.
    </div>
  } @else {
    <div class="detail-card">
      <header>Please Provide the following details to the Development Team:</header>
      <code>
        <pre><p data-testid="global-error-details">{{config?.details | json}}</p></pre>
      </code>
    </div>
    @if (config?.details?.connectionError) {
      <app-page-alert
        [alert]="{
          status: 'info',
          message: 'This seems to be a Server/Connection error. Please, try again after a few minutes.'
        }"
        aria-live="polite"
      >
      </app-page-alert>
    }
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    [mat-dialog-close]="true"
    data-testid="global-error-close"
    (click)="close()"
    cdkFocusInitial
    color="primary"
    mat-raised-button
    aria-label="Ok"
    tabindex="0"
  >
    OK
  </button>
  @if (config?.devMode) {
    <button
      color="primary"
      mat-raised-button
      aria-label="Copy details to Clipboard"
      [cdkCopyToClipboard]="config?.details | json"
      tabindex="0"
    >
      Copy details to Clipboard
    </button>
  }
  <button (click)="generateHar()" color="primary" mat-raised-button aria-label="Generate Log" tabindex="0">Generate Log</button>
  <a id="blobLink" style="display: none" tabindex="0" role="link"></a>
</mat-dialog-actions>
